/**
 * Prefix a bare host/path with `https://` so it is safe for `<a href>` /
 * `<Link href>`. Trims first and passes empty / whitespace-only input
 * through as `""` — never renders a dead `"https://"` link.
 */
export function ensureAbsoluteUrl(url: string): string {
  const t = url.trim();
  if (!t) return t;
  if (t.startsWith("http://") || t.startsWith("https://")) return t;
  return `https://${t}`;
}
